import type { AssignmentCriterion } from "@markeroo/shared";
import PiSparkleAI01Stroke from "@markeroo/icons/src/stroke/general/PiSparkleAI01Stroke";
import { cardContainer, mutedText } from "@/styles/variants";
import { buttonVariants, cssVars } from "@markeroo/theme";
import { ui } from "@/strings";
import { highlightingBasedOn } from "@/strings/labels";
import { Tooltip } from "@/components/Tooltip";

interface CriteriaSummaryCardProps extends React.HTMLAttributes<HTMLElement> {
  criteria: AssignmentCriterion[];
  onOpenManager: () => void;
}

export function CriteriaSummaryCard({ criteria, onOpenManager, ...props }: CriteriaSummaryCardProps) {
  const count = criteria.length;
  return (
    <section className={`${cardContainer} gap-4`} data-tutorial-target="criteria-summary" {...props}>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-2">
          <PiSparkleAI01Stroke size={24} className="flex-shrink-0 mt-0.5 sm:mt-1" color={cssVars.highlight} />
          <div>
            <h2 className="text-lg sm:text-xl font-semibold text-theme-primary inline-flex items-center gap-2">
              {ui.headers.criteriaTemplateForHighlighting}
              <Tooltip content={ui.labels.criteriaHelp} />
            </h2>
            <p className={mutedText}>
              {highlightingBasedOn(count)}
            </p>
          </div>
        </div>
        <button type="button" className={`${buttonVariants.primary} w-full sm:w-auto sm:flex-shrink-0`} onClick={onOpenManager}>
          {ui.actions.manageCriteriaTemplate}
        </button>
      </div>
    </section>
  );
}
